export const getExpirationDateOneYear = () => {
  const oneYearFromToday = new Date();
  oneYearFromToday.setFullYear(oneYearFromToday.getFullYear() + 1);

  return oneYearFromToday.toUTCString();
};

export const saveCookie = (key: string, value: unknown, expiration?: string, sameSite: "Lax" | "Strict" | "None" = "None", secure = true) => {
  expiration ??= getExpirationDateOneYear();
  const secureStr = secure || sameSite === "None" ? "secure;" : "";

  const cookieAttributes = `path=/;${secureStr}expires=${expiration};domain=${location.hostname};SameSite=${sameSite}`;

  const formattedContent = typeof value === "string" ? encodeURIComponent(value) : encodeURIComponent(JSON.stringify(value));

  document.cookie = `${key}=${formattedContent};${cookieAttributes}`;
};

export const readCookie = (key: string) => {
  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${key}=`))
    ?.split("=")[1];

  if (cookie) {
    return cookie;
  }
  return null;
};

export const removeCookie = (key: string, sameSite: "Lax" | "Strict" | "None" = "None", secure = true) => {
  const expired = "Thu, 01 Jan 1970 00:00:00 GMT";
  const secureStr = secure || sameSite === "None" ? "secure;" : "";

  const cookieAttributes = `path=/;${secureStr}expires=${expired};domain=${location.hostname};SameSite=${sameSite}`;

  document.cookie = `${key}=;${cookieAttributes}`;
};
